import { UntypedFormGroup } from '@angular/forms';
import { Error } from 'src/app/models/error';

export function checkForValidationErrors(e: Error, form: UntypedFormGroup) {
  if (e.validationErrors) {
    e.validationErrors.forEach((fieldError) => {
      if (fieldError.fieldName) {
        form.controls[fieldError.fieldName].setErrors(e.validationErrors.filter(field => field.fieldName == fieldError.fieldName));
      }
    });
    form.markAllAsTouched();
  }
}
